import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { formatters, TRANSFER_TYPES } from 'common';
import classNames from 'classnames';
import DefListColumn from 'components/DefListColumn';
import messages from './messages';
import styles from './styles.css';

const DetailsHeader = ({
  allowEditAmount,
  allowEditAccount,
  amount,
  amountAvailableTotal,
  apexAccountNumber,
  correspondentName,
  onEditAmountButtonClicked,
  onEditAccountButtonClicked,
  method,
  direction,
  state,
  reject,
  hasReturn,
  rejectAction,
  cancel,
  cancelAction,
  reopen,
  reopenAction,
  suspend,
  suspendAction,
  returnAction,
  isFirstPartyJournal,
}) => {
  const isPositionJournal = method === TRANSFER_TYPES.positionJournal;
  return (
    <div className={styles.header}>
      <div className={styles['header-left']}>
        <span className={styles.badge} data-test-handle="transferBadge">
          <span>Type</span>
          <span>
            {isFirstPartyJournal && formatters.formatTransferType(method)}
            {!isFirstPartyJournal &&
              `${formatters.formatTransferType(method)} ${formatters.formatTitleCase(direction)}`}
          </span>
        </span>
        <DefListColumn
          className={classNames(styles.defList, styles.amount)}
          title={
            <span>
              <FormattedMessage {...messages.account} />
            </span>
          }
          data={apexAccountNumber}
          dataTestHandle="account"
          edit={
            <span>
              {allowEditAccount && (
                <button
                  className={classNames(styles.editAmountButton, apexAccountNumber === '' && styles.emptyEditableField)}
                  onClick={onEditAccountButtonClicked}
                  data-test-handle="editAccountButton"
                >
                  Edit
                </button>
              )}
            </span>
          }
        />
        <DefListColumn
          className={classNames(styles.defList, styles.amount)}
          title={
            <span className={styles.amountTitle}>
              <FormattedMessage {...messages.amount} />
            </span>
          }
          data={formatters.formatDollars(amount)}
          dataTestHandle="amount"
          edit={
            <span>
              {allowEditAmount && (
                <button
                  className={styles.editAmountButton}
                  onClick={onEditAmountButtonClicked}
                  data-test-handle="editAmountButton"
                >
                  Edit
                </button>
              )}
            </span>
          }
        />
        {!isPositionJournal && (
          <DefListColumn
            className={styles.defList}
            title={<FormattedMessage {...messages.amountAvailable} />}
            data={formatters.formatDollars(amountAvailableTotal)}
            dataTestHandle="amountAvailable"
          />
        )}
        <DefListColumn
          className={styles.defList}
          title={<FormattedMessage {...messages.state} />}
          data={state}
          dataTestHandle="state"
        />
        <DefListColumn
          className={styles.defList}
          title={<FormattedMessage {...messages.correspondent} />}
          data={formatters.formatCorrespondentName(correspondentName)}
          dataTestHandle="correspondent"
        />
      </div>
      {/* ///////////////////////////////////////
    ///////// User Action buttons ////////////
    ///////////////////////////////////////// */}
      <div className={styles['header-right']}>
        {cancel && (
          <button onClick={cancelAction} className="buttons buttons-orange" data-test-handle="cancelTransfer">
            <FormattedMessage {...messages.cancelTransfer} />
          </button>
        )}

        {suspend && (
          <button onClick={suspendAction} className="buttons buttons-orange" data-test-handle="suspendTransfer">
            <FormattedMessage {...messages.suspendTransfer} />
          </button>
        )}

        {reject && (
          <button
            onClick={rejectAction}
            className="btn-offset-left buttons buttons-negative"
            data-test-handle="rejectTransfer"
          >
            <FormattedMessage {...messages.rejectTransfer} />
          </button>
        )}

        {reopen && (
          <button
            onClick={reopenAction}
            className="btn-offset-left buttons buttons-gray"
            data-test-handle="reopenTransfer"
          >
            <FormattedMessage {...messages.reopenTransfer} />
          </button>
        )}

        {hasReturn && (
          <button
            onClick={returnAction}
            className="btn-offset-left buttons buttons-orange"
            data-test-handle="returnTransfer"
          >
            <FormattedMessage {...messages.returnTransfer} />
          </button>
        )}
      </div>
    </div>
  );
};

DetailsHeader.propTypes = {
  allowEditAmount: PropTypes.bool.isRequired,
  allowEditAccount: PropTypes.bool.isRequired,
  amount: PropTypes.number.isRequired,
  amountAvailableTotal: PropTypes.number.isRequired,
  apexAccountNumber: PropTypes.string.isRequired,
  correspondentName: PropTypes.string.isRequired,
  onEditAmountButtonClicked: PropTypes.func.isRequired,
  onEditAccountButtonClicked: PropTypes.func.isRequired,
  method: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  direction: PropTypes.string.isRequired,
  reject: PropTypes.bool,
  rejectAction: PropTypes.func.isRequired,
  reopen: PropTypes.bool,
  cancel: PropTypes.bool.isRequired,
  cancelAction: PropTypes.func.isRequired,
  reopenAction: PropTypes.func.isRequired,
  suspend: PropTypes.bool,
  suspendAction: PropTypes.func.isRequired,
  hasReturn: PropTypes.bool.isRequired,
  returnAction: PropTypes.func.isRequired,
  isFirstPartyJournal: PropTypes.bool.isRequired,
  positionDetails: PropTypes.shape({
    quantity: PropTypes.number.isRequired,
    securityIdType: PropTypes.string.isRequired,
    securityId: PropTypes.string.isRequired,
    price: PropTypes.number,
    journalType: PropTypes.string.isRequired,
    destinationAccountNumber: PropTypes.string.isRequired,
  }),
};

DetailsHeader.defaultProps = {
  reject: false,
  reopen: false,
  suspend: false,
  positionDetails: null,
};

export default DetailsHeader;



// WEBPACK FOOTER //
// ./src/components/DetailsHeader/index.js